import { render } from "./PointEvent.vue?vue&type=template&id=0d9c20b2&scoped=true"
import script from "./PointEvent.vue?vue&type=script&lang=js"
export * from "./PointEvent.vue?vue&type=script&lang=js"

import "./PointEvent.vue?vue&type=style&index=0&id=0d9c20b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9c20b2"]])

export default __exports__